let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d9485")).then(() => parcelRequire('j6egZ'));